import ReactPaginate from 'react-paginate'

import type { MetaResponse } from '../../../store/types'
import { LeftArrow, RightArrow } from '../../icons/general'

type NumberedPaginationProps = {
  meta?: MetaResponse<any>
  onNext: Function
  onPrev: Function
  onSelect: (page: number) => void
  currentPage: number
  isInitiated?: boolean
}

export default function NumberedPagination({
  meta,
  onNext,
  onPrev,
  onSelect,
  currentPage,
  isInitiated = true,
}: NumberedPaginationProps): JSX.Element {
  if (!isInitiated) {
    return (
      <div className="py-8 flex flex-row justify-between">
        <div className="animate-pulse sm:hidden rounded-lg w-10 h-10  bg-gray-200"></div>
        <div className="animate-pulse mt-2.5 sm:hidden bg-gray-200 h-7 w-24 rounded"></div>
        <div className="animate-pulse sm:hidden border bg-gray-200 rounded-lg w-10 h-10 "></div>
        <div className="hidden sm:flex animate-pulse bg-gray-200 w-40 h-5 rounded-md"></div>
        <div className="hidden sm:flex flex-row space-x-2 justify-center items-center">
          <div className="animate-pulse bg-gray-200 h-10 w-1/6 rounded-lg"></div>
          <div className="animate-pulse bg-gray-200 h-10 w-1/6 rounded-lg"></div>
          <div className="animate-pulse bg-gray-200 h-10 w-1/6 rounded-lg"></div>
          <div className="animate-pulse bg-gray-200 h-10 w-1/6 rounded-lg"></div>
          <div className="animate-pulse bg-gray-200 h-10 w-1/6 rounded-lg"></div>
          <div className="animate-pulse bg-gray-200 h-10 w-1/6 rounded-lg"></div>
        </div>
        <div className="hidden sm:flex animate-pulse bg-gray-200 w-40 h-5 rounded-md"></div>
      </div>
    )
  }
  const handlePageChange = ({ selected: selectedPage }: { selected: number }) =>
    onSelect(selectedPage + 1)

  return (
    <>
      <div className="py-8 flex flex-row justify-between">
        <button
          type="button"
          onClick={(e) => {
            if (meta?.hasPreviousPage) {
              onPrev()
            }
          }}
          disabled={!meta?.hasPreviousPage}
          className="flex sm:hidden items-center justify-center border border-solid border-gray-300 disabled:border-gray-200 rounded-lg w-9 h-9 active:bg-gray-50"
        >
          <LeftArrow stroke={!meta?.hasPreviousPage ? '#EAECF0' : '#344054'} />
        </button>
        <span className="font-medium text-sm text-gray-900 pt-2 flex sm:hidden">
          Page {meta?.page} of {meta?.totalPages}
        </span>
        <button
          className="flex sm:hidden items-center justify-center border border-solid border-gray-300 disabled:border-gray-200 rounded-lg w-9 h-9 active:bg-gray-50"
          type="button"
          onClick={() => {
            if (meta?.hasNextPage) {
              onNext()
            }
          }}
          disabled={!meta?.hasNextPage}
        >
          <RightArrow stroke={!meta?.hasNextPage ? '#EAECF0' : '#344054'} />
        </button>
        <button
          className="font-medium text-sm text-gray-500 pl-2 hidden sm:flex flex-row items-center gap-x-2 disabled:text-gray-200"
          type="button"
          onClick={(e) => {
            if (meta?.hasPreviousPage) {
              onPrev()
            }
          }}
          disabled={!meta?.hasPreviousPage}
        >
          <LeftArrow stroke={!meta?.hasPreviousPage ? '#EAECF0' : '#344054'} />
          Previous
        </button>
        <ReactPaginate
          className="hidden sm:flex justify-center items-center"
          previousClassName="hidden"
          nextClassName="hidden"
          pageLinkClassName="rounded-lg text-sm px-4 min-w-10 h-10 text-gray-500 flex justify-center items-center active:bg-gray-100"
          activeLinkClassName="text-gray-800 bg-gray-50"
          breakClassName="text-sm w-10 h-10 text-gray-500 flex justify-center items-center"
          breakLabel="..."
          pageCount={meta?.totalPages ?? 0}
          marginPagesDisplayed={3}
          pageRangeDisplayed={3}
          onPageChange={handlePageChange}
          forcePage={currentPage - 1}
        />
        <div className="hidden sm:flex flex-row items-center">
          <button
            className="font-medium text-sm text-gray-500 pr-2 disabled:text-gray-200"
            type="button"
            onClick={() => {
              if (meta?.hasNextPage) {
                onNext()
              }
            }}
            disabled={!meta?.hasNextPage}
          >
            Next
          </button>
          <RightArrow stroke={!meta?.hasNextPage ? '#EAECF0' : '#344054'} />
        </div>
      </div>
    </>
  )
}
